export default "__VITE_ASSET__1ebd393d__"